var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1460_855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97885 12.004L5.63031 11.7052C5.14982 11.3029 0.954346 7.67955 0.954346 5.02915C0.954346 2.25419 3.2039 0.00463867 5.97885 0.00463867C8.75381 0.00463867 11.0034 2.25419 11.0034 5.02915C11.0034 7.67958 6.80788 11.3029 6.32938 11.7072L5.97885 12.004ZM5.97885 1.09108C3.80495 1.09354 2.04328 2.85522 2.04081 5.02912C2.04081 6.69417 4.62203 9.35404 5.97885 10.5715C7.3357 9.35355 9.91689 6.69215 9.91689 5.02912C9.91443 2.85522 8.15277 1.09357 5.97885 1.09108Z",
    fill: "#52555F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97898 7.0207C4.87901 7.0207 3.9873 6.12899 3.9873 5.02903C3.9873 3.92906 4.87901 3.03735 5.97898 3.03735C7.07895 3.03735 7.97065 3.92906 7.97065 5.02903C7.97065 6.12899 7.07897 7.0207 5.97898 7.0207ZM5.97898 4.03317C5.42899 4.03317 4.98314 4.47902 4.98314 5.029C4.98314 5.57899 5.42899 6.02484 5.97898 6.02484C6.52896 6.02484 6.97481 5.57899 6.97481 5.029C6.97481 4.47902 6.52898 4.03317 5.97898 4.03317Z",
    fill: "#52555F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1460_855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f04d3c229c7fec6543f09ee218ab9e86.svg";
export { ForwardRef as ReactComponent };